import type { UUID } from '@/types/common'
import type { CreateUserRequest, UpdateUserRequest, User, UsersResponse } from '@/types/user'

import { api } from './client'

export interface GetUsersParams {
  name?: string;
  email?: string;
  role?: string;
  companyIDs?: UUID[];
  createdAfter?: string;
  createdBefore?: string;
  page?: number;
  limit?: number;
  sort?: string[];
}

export const usersApi = {
  getUsers: (params?: GetUsersParams) =>
    api.get<UsersResponse>('/users', params),

  createUser: (data: CreateUserRequest) =>
    api.post<User>('/users', data),

  getUser: (id: UUID) =>
    api.get<User>(`/users/${id}`),

  updateUser: (id: UUID, data: UpdateUserRequest) =>
    api.put<User>(`/users/${id}`, data),

  deleteUser: (id: UUID) =>
    api.delete<void>(`/users/${id}`),
}
